import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <motion.header
            className={`sticky top-0 z-10 py-4 transition-all duration-300 ${isScrolled
                ? 'bg-white bg-opacity-95 backdrop-blur-sm shadow-md'
                : 'bg-transparent'
                }`}
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            transition={{ type: 'spring', stiffness: 100, damping: 20 }}
        >
            <div className="container mx-auto px-4 flex justify-between items-center">
                <Link to="/" className="flex items-center space-x-2">
                    <motion.div
                        className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-tertiary flex items-center justify-center"
                        whileHover={{ rotate: 10, scale: 1.1 }}
                        transition={{ type: 'spring', stiffness: 400, damping: 10 }}
                    >
                        <span className="text-white font-bold text-xl">M</span>
                    </motion.div>
                    <div className="text-xl font-bold">
                        <span className="primary-gradient">MCP Server</span>
                        <span className="text-gray-800"> Tool</span>
                    </div>
                </Link>

                <nav className="hidden md:flex space-x-1">
                    <NavLink to="/" isActive={location.pathname === '/'}>
                        Home
                    </NavLink>
                    <NavLink to="/reference-servers" isActive={location.pathname === '/reference-servers' || location.pathname.startsWith('/reference-servers/')}>
                        Reference Servers
                    </NavLink>
                    <NavLink to="/thirdparty-servers" isActive={location.pathname === '/thirdparty-servers' || location.pathname.startsWith('/thirdparty-servers/')}>
                        Third-Party Servers
                    </NavLink>
                    <NavLink to="/community-servers" isActive={location.pathname === '/community-servers' || location.pathname.startsWith('/community-servers/')}>
                        Community-Servers
                    </NavLink>
                </nav>

                <MobileMenu location={location} />
            </div>
        </motion.header>
    );
};

const NavLink = ({ to, children, isActive }) => {
    return (
        <Link
            to={to}
            className={`nav-link font-medium ${isActive ? 'active text-primary' : 'text-gray-700'}`}
        >
            {children}
            {isActive && (
                <motion.span
                    className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-primary to-secondary"
                    layoutId="underline"
                />
            )}
        </Link>
    );
};

const MobileMenu = ({ location }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="md:hidden">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2"
                aria-label="Toggle menu"
            >
                <div className="w-6 h-5 flex flex-col justify-between">
                    <span className={`block h-0.5 bg-gray-800 transition-all ${isOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                    <span className={`block h-0.5 bg-gray-800 transition-all ${isOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                    <span className={`block h-0.5 bg-gray-800 transition-all ${isOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                </div>
            </button>

            {isOpen && (
                <motion.div
                    className="absolute top-full left-0 right-0 bg-white p-4 shadow-lg"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                >
                    <div className="flex flex-col space-y-2">
                        <MobileNavLink to="/" isActive={location.pathname === '/'} onClick={() => setIsOpen(false)}>
                            Home
                        </MobileNavLink>
                        <MobileNavLink to="/reference-servers" isActive={location.pathname === '/reference-servers' || location.pathname.startsWith('/reference-servers/')} onClick={() => setIsOpen(false)}>
                            Reference Servers
                        </MobileNavLink>
                        <MobileNavLink to="/thirdparty-servers" isActive={location.pathname === '/thirdparty-servers' || location.pathname.startsWith('/thirdparty-servers/')} onClick={() => setIsOpen(false)}>
                            Third-Party Servers
                        </MobileNavLink>
                        <MobileNavLink to="/community-servers" isActive={location.pathname === '/community-servers' || location.pathname.startsWith('/community-servers/')} onClick={() => setIsOpen(false)}>
                            Community Servers
                        </MobileNavLink>
                    </div>
                </motion.div>
            )}
        </div>
    );
};

const MobileNavLink = ({ to, children, isActive, onClick }) => {
    return (
        <Link
            to={to}
            className={`block p-2 ${isActive ? 'text-primary' : 'text-gray-800'}`}
            onClick={onClick}
        >
            {children}
        </Link>
    );
};

export default Header;